import { z } from "zod";
import { ReportReason, ReportTargetType } from "../enum.js";

export const createReportSchema = z
	.object({
		target_type: z.enum(ReportTargetType),
		target_id: z.uuid({ message: "Invalid target ID" }),
		reason: z.enum(ReportReason),
		description: z.string().max(1000, { message: "Description must be at most 1000 characters" }).optional(),
	})
	.strict();

export type CreateReportPayload = z.infer<typeof createReportSchema>;
